









































































































































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { fromEvent } from 'rxjs';
import { Prop } from 'vue-property-decorator';
import BoxMainView from '@/components/box/main-view.vue';
import TitleLarge from '@/components/title/large.vue';
import TextBody from '@/components/text/body.vue';
import BoxEntry from '@/components/box/entry.vue';

@Component({
  components: {
    BoxMainView,
    TitleLarge,
    TextBody,
    BoxEntry,
  },
})
export default class Vision extends Vue {

  /**
   * ページタイトル
   */
  @Prop()
  public title!: string;

  /**
   * アニメーションフラグ
   */
  private isAnimate: boolean = false;

  /**
   * アニメーション終了フラグ
   */
  private isAnimateEnd: boolean = false;

  /**
   * アニメーション終了フラグ
   */
  private isFix: boolean = false;

  /**
   * トップからの遷移か
   */
  private toTop: boolean = false;

  /**
   * createdフック
   */
  public created(): void {
    document.title = this.title;
  }

  /**
   * mountedフック
   */
  public mounted(): void {
    // fixed解除
    const target: any = document.getElementById('pop-image');

    if (target) {
      this.toTop = true;
      setTimeout((): void => {
        document.body.removeChild(target);
        document.body.style.overflow = 'auto';
        this.$store.commit('setFixed', false);
        this.isAnimate = true;
      }, 100);
    } else {
      document.body.style.overflow = 'auto';
      this.$store.commit('setFixed', false);
      this.isAnimate = true;
      this.isFix = true;
    }

    fromEvent(window, 'scroll').subscribe((event: any): void => {
      this.isAnimateEnd = true;
    });
  }

}
